// THIS FILE IS AUTO GENERATED! Local values are for development only.
export const version = {
  hash: '23739ffd9ecf8f9133c515dc74cf8fc1e30fca90',
  hashShort: '23739ff'
};
